import { render, staticRenderFns } from "./tab-combination-pick.vue?vue&type=template&id=447c7746&scoped=true&"
import script from "./tab-combination-pick.vue?vue&type=script&lang=js&"
export * from "./tab-combination-pick.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/loto/tab-common.scss?vue&type=style&index=0&id=447c7746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c7746",
  null
  
)

export default component.exports